import styles from "./TotalComponent.module.scss";
import FlexRow from "./FlexRow";
import React from "react";

interface Props {
    firstHeader: string;
    firstTotal: string;
    firstIcon: React.ReactElement;
    secondHeader: string;
    secondTotal: string;
    secondIcon: React.ReactElement;
    thirdHeader: string;
    thirdTotal: string;
    thirdIcon: React.ReactElement;
    fourthHeader: string;
    fourthTotal: string;
    fourthIcon: React.ReactElement;
}

const TotalComponent = (props: Props) => {

    return (
        <FlexRow justify={"end"} style={{paddingTop: 10}}>
            <div className={styles.totalContainer}>
                <div className={`${styles.content} ${styles.first}`}>
                    {React.cloneElement(props.firstIcon, {fill: 'red', height: 30, width: 30})}
                    <div>
                        <span className={styles.header}>
                            {props.firstHeader}
                        </span>
                        <span className={styles.total}>
                            {props.firstTotal}
                        </span>
                    </div>
                </div>
                <div className={`${styles.content} ${styles.first}`}>
                    {React.cloneElement(props.secondIcon, {fill: 'red', height: 30, width: 30})}
                    <div>
                        <span className={styles.header}>
                            {props.secondHeader}
                        </span>
                        <span className={styles.total}>
                            {props.secondTotal}
                        </span>
                    </div>
                </div>
                <div className={`${styles.content} ${styles.first}`}>
                    {React.cloneElement(props.secondIcon, {fill: 'red', height: 30, width: 30})}
                    <div>
                        <span className={styles.header}>
                            {props.thirdHeader}
                        </span>
                        <span className={styles.total}>
                            {props.thirdTotal}
                        </span>
                    </div>
                </div>
                <div className={`${styles.content} ${styles.last}`}>
                    {React.cloneElement(props.fourthIcon, {fill: 'white', height: 30, width: 30})}
                    <div>
                        <span className={styles.header}>
                            {props.fourthHeader}
                        </span>
                        <span className={styles.total}>
                            {props.fourthTotal}
                        </span>
                    </div>
                </div>

            </div>
        </FlexRow>
    )

}

type V2Props = {
    items: {
        icon: React.ReactElement;
        header: string;
        total: string;
    }[]
}
export const TotalComponentV2 = (props: V2Props) => {

    return (
        <FlexRow justify={"end"} style={{paddingTop: 10}}>
            <div className={styles.totalContainer}>
                {props.items.map((item, index) => (
                    <div key={item.header} className={`${styles.content} ${index !== props.items.length - 1 ? styles.first : styles.last}`}>
                        {React.cloneElement(item.icon, {fill: index !== props.items.length - 1 ? 'red' : 'white', height: 30, width: 30})}
                        <div>
                        <span className={styles.header}>
                            {item.header}
                        </span>
                            <span className={styles.total}>
                            {item.total}
                        </span>
                        </div>
                    </div>
                ))}
            </div>
        </FlexRow>
    )

}

export default TotalComponent